module.exports = __webpack_public_path__ + "img/1961.7bb3dc1f.jpg";